import { render, staticRenderFns } from "./ControlPanel.vue?vue&type=template&id=11fbc0a4&scoped=true&"
var script = {}
import style0 from "./ControlPanel.vue?vue&type=style&index=0&id=11fbc0a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fbc0a4",
  null
  
)

export default component.exports